import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { LAYER_IDS, COLOR } from '@tmapy/beetlejuice-utils';
import { actionSetExtent, getExtent, actionSetLayerFeatureHighlight, isGeoJSONFeature, } from '@tmapy/mapcore';
import { useDispatch } from '@tmapy/redux';
import { FormItem, FormRow, ListItem } from '@tmapy/style-guide';
import { itemMessages } from '../messages';
export const SearchResultItem = React.memo(({ feature, isHighlighted, zoom, tabId, getMapPadding }) => {
    const dispatch = useDispatch();
    const handleClick = useCallback(() => {
        const mapPadding = getMapPadding();
        const featureGeometryExtent = getExtent(feature);
        featureGeometryExtent && dispatch(actionSetExtent(featureGeometryExtent, mapPadding, zoom));
    }, [dispatch, feature]);
    const handleMouseEnter = useCallback(() => {
        dispatch(actionSetLayerFeatureHighlight({
            highlightedFeatures: [
                { layerId: `${LAYER_IDS.SEARCH}-${tabId}`, featureId: feature.id, feature },
            ],
            coordinate: null,
        }));
    }, [dispatch, feature]);
    const handleMouseLeave = useCallback(() => {
        dispatch(actionSetLayerFeatureHighlight({
            highlightedFeatures: [],
            coordinate: null,
        }));
    }, [dispatch]);
    // Because of "coords" tab
    const geoJSONFeature = useMemo(() => {
        if (isGeoJSONFeature(feature)) {
            return feature;
        }
        return {
            type: 'Feature',
            id: feature.attributes.id,
            properties: feature.attributes,
            geometry: {
                type: 'Point',
                coordinates: [feature.geometry.x, feature.geometry.y],
            },
        };
    }, [feature]);
    return (_jsx(ListItem, { data: feature, stripePosition: 'right', isActive: isHighlighted, color: `rgb(${COLOR.HIGHLIGHT[0]}, ${COLOR.HIGHLIGHT[1]}, ${COLOR.HIGHLIGHT[2]})`, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onPress: handleClick, children: _jsx("div", { className: 'sg-a-py-1 sg-a-mx-2 sg-u-vs-1', children: _jsx(FormattedMessage, { id: `search.${tabId}.item.content.html`, ...itemMessages[tabId], values: {
                    ...feature,
                    ...geoJSONFeature.properties,
                    ITEM: (children) => {
                        const length = children.length;
                        const label = length === 2 && typeof children[0] === 'string' ? children[0] : undefined;
                        if (length === 1 || label) {
                            return (_jsx(FormRow, { children: _jsx(FormItem, { label: label, children: children[length - 1] }) }));
                        }
                        return null;
                    },
                    LABEL: (children) => (typeof children[0] === 'string' ? children[0] : null),
                    VALUE: (children) => (typeof children[0] === 'string' ? _jsx(_Fragment, { children: children[0] }) : null),
                } }) }) }));
});
//# sourceMappingURL=SearchResultItem.js.map